import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const indicators = [
    {
      icon: 'Shield',
      label: 'Secure Registration',
      description: 'Your data is protected with enterprise-grade security'
    },
    {
      icon: 'Lock',
      label: 'Encrypted Storage',
      description: 'All information is encrypted and stored securely'
    },
    {
      icon: 'CheckCircle',
      label: 'Trusted Platform',
      description: 'Used by professional journalists worldwide'
    }
  ];

  return (
    <div className="mt-8">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
        {indicators?.map((indicator, index) => (
          <div key={index} className="flex flex-col items-center space-y-2">
            <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name={indicator?.icon} size={18} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-xs font-medium text-foreground">
                {indicator?.label}
              </p>
              <p className="text-xs text-muted-foreground mt-1 hidden sm:block">
                {indicator?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustIndicators;